import mojs from 'mo-js';
import MojsPlayer from 'mojs-player';
import MojsCurveEditor from 'mojs-curve-editor';

const star = require('./star.js');
const heart = require('./heart.js');

// const scaleCurve = new MojsCurveEditor({ name: 'scale' });

// const square1 = new mojs.Html({
//   el: '#js-el',
//   y: { [-300]: -300, curve: 'M0, 0 C10.101525445522112, -1.5300968740935288 24.578551642263555, 1.7142857142857142 30, 87.42857142857143 C33.06687772061731, 107.14285714285714 50, 107 50, 107 C50, 107 62.917147228930936, 104.99294035155644 70, 87.14285714285714 C74.31276966857592, 6.435631077014981 90.03697870960255, 0.67295401695068 100, 0 ' },
//   scaleX: { 1: 1, curve: scaleCurve.getEasing() },
//   duration: 1000
// })
// new MojsPlayer({ add: square1 });

let totalClicks = 0;

const playBurst = (posX, posY, e) => {
  burst
    .tune({ x: posX, y: posY })
    .generate()
    .replay();

  burst1
    .tune({ x: posX, y: posY })
    .generate()
    .replay();

  // largeBurst
  //   .tune({ x: posX, y: posY })
  //   .replay();

  largeCircle
    .tune({ x: posX, y: posY })
    .replay();

  smallCircle
    .tune({ x: posX, y: posY })
    .replay();

  if(totalClicks%2 === 0) {
    star(e);
  } else {
    heart(e);
  }

  ++totalClicks;

}
// or gui controls instead of `.play()` call
// new MojsPlayer({ add: burst, isPlaying: true, isRepeat: true });

const COLORS = {
  RED:      '#FD5061',
  YELLOW:   '#FFCEA5',
  BLACK:    '#29363B',
  WHITE:    'white',
  VINOUS:   '#A50710'
}

const burst = new mojs.Burst({
  radius: { 25 : 75 },
  count: 10,
  isSoftHide: true,
  left: 0,
  top: 0,

  duration: 2000,
  onComplete () {
    // console.log( 'completed' );
  },
  children: {
    // property map - maps over children with mod function
    shape: [ 'circle', 'polygon' ],
    // property map - maps over children with mod function
    fill:  [ '#333', 'magenta', 'purple' ],
    angle: { 0: 180 },
    // rand string - generates random value for every child rand( min, max )
    degreeShift: 'rand(-360, 360)',
    // stagger string( start, step ) for every child
    delay: 'stagger(0, 25)',
  }
})

const burst1 = new mojs.Burst({
  left: 0, top: 0,
  count:          8,
  radius:         { 50: 150 },
  children: {
    shape:        'line',
    stroke:       [ 'white', '#FFE217', '#FC46AD', '#D0D202', '#B8E986', '#D0D202' ],
    scale:        1,
    scaleX:       { 1 : 0 },
    // pathScale:    'rand(.5, 1.25)',
    degreeShift:  'rand(-90, 90)',
    radius:       'rand(20, 40)',
    // duration:     200,
    delay:        'rand(0, 150)',
    isForce3d:    true
  }
});

const largeBurst = new mojs.Burst({
  left: 0, top: 0,
  count:          4,
  radius:         0,
  angle:         45,
  radius:        { 0: 450  },
  children: {
    shape:        'line',
    stroke:       '#4ACAD9',
    scale:        1,
    scaleX:       { 1 : 0 },
    radius:       100,
    duration:     450,
    isForce3d:    true,
    easing:       'cubic.inout'
  }
});

const CIRCLE_OPTS = {
  left: 0, top: 0,
  scale: { 0: 1 },
}

const largeCircle = new mojs.Shape({
  left: 0, top: 0,
  scale: { 0: 1 },
  fill:       'none',
  stroke:     'white',
  strokeWidth: 4,
  opacity:    { .25 : 0 },
  radius:     250,
  duration:   600,
});

const smallCircle = new mojs.Shape({
  left: 0, top: 0,
  scale: { 0: 1 },
  fill:       'white',
  opacity:    { .5 : 0 },
  radius:     30,
});


document.addEventListener('click', (e) => {
  // console.log('click');
  playBurst(e.clientX, e.clientY, e);
}, true);


// WEBPACK FOOTER //
// ./src/main.js